/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem
     */
    delivery_hours?: number;
}

export function DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem {
    return DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'delivery_hours': !exists(json, 'delivery_hours') ? undefined : json['delivery_hours'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsDeliveryOptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'delivery_hours': value.delivery_hours,
    };
}


